import c from "./component-library239.js";
import { ref as s, onMounted as a, onBeforeUnmount as f } from "vue";
const w = (o, e) => {
  if (!["ArrowDown", "ArrowUp"].includes(e.key) || !o?.value) return;
  const l = "$el" in o.value ? o.value.$el : o.value;
  if (!l?.querySelectorAll) return;
  const n = l.querySelectorAll(c.join(", "));
  if (n.length === 0) return;
  const t = Array.prototype.indexOf.call(n, e.target);
  let r = t;
  e.key === "ArrowDown" ? (r = t + 1, r >= n.length && (r = 0)) : e.key === "ArrowUp" && (r = t - 1, r < 0 && (r = n.length - 1));
  const u = n[r];
  u && (e.preventDefault(), u.focus());
}, i = (o, e, l = void 0) => {
  if (e.key === "Tab") {
    if (!o?.value) return;
    const n = "$el" in o.value ? o.value.$el : o.value;
    if (!n?.querySelectorAll) return;
    const t = n.querySelectorAll(c.join(", "));
    if (t.length === 0) return;
    const r = t[0], u = t[t.length - 1];
    e.type === "keyup" ? console.error(
      // eslint-disable-next-line max-len
      `Focus trap does not work with "keyup". You'll have to use "keydown", otherwise the focus may be gone outside the Browser.`
    ) : (e.target === u && !e.shiftKey && (e.preventDefault(), r.focus()), e.target === r && e.shiftKey && (e.preventDefault(), u.focus()));
  }
  l && l(e);
}, d = (o = void 0) => {
  const e = s(null), l = s((r) => {
    if (!e.value) {
      t();
      return;
    }
    i(e, r, o);
  }), n = (r) => {
    e.value = r.value, document.addEventListener("keydown", l.value, !0);
  }, t = () => {
    document.removeEventListener("keydown", l.value, !0);
  };
  return {
    add: n,
    remove: t,
    handleKeyEvent: l
  };
}, h = (o) => {
  const e = d();
  return a(() => {
    e.add(o);
  }), f(() => {
    e.remove();
  }), e;
};
export {
  d as addFocusTrap,
  w as focusElement,
  i as focusTrap,
  h as useFocusTrap
};
